import Footer from './common/Footer';
import Header from './common/Header';
import AppRouter from './routes/appRouter';
// Suppress TS error when no type declarations exist for CSS side-effect imports
// @ts-ignore
import './App.css';

function App() {
  return (
    <div className="relative min-h-screen overflow-hidden bg-white text-black transition-colors duration-500 dark:bg-black dark:text-white">
      {/* Background blobs */}
      <div className="absolute inset-0 z-0">
        <span className="bg-blob bg-purple" />
        <span className="bg-blob bg-pink" />
        <span className="bg-blob bg-indigo" />
      </div>

      {/* App content */}
      <div className="relative z-10">
        <Header />
        <main>
          <AppRouter />
        </main>
        <Footer />
      </div>
    </div>
  );
}

export default App;
